document.addEventListener('click', (e) => {
  const button = e.target.closest('.gf-filter-contents .gf-option-box button');
  if (button) {
    const target = document.querySelector('#gf-grid');
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
});
(() => {
  // Filter integration only belongs on collections and search results.
  if (!document.body.matches('.template-collection, .template-search')) return;
  const initialized = new WeakSet();
  let pending = false;
  const prepare = () => {
    pending = false;
    const tree = document.querySelector('#gf-tree');
    const source = document.querySelector('#gf-controls-container .sort-by');
    if (!tree || typeof window.globofilter?.toggleCanvas !== 'function') return;
    if (!document.documentElement.classList.contains('ji-globo-ready')) document.documentElement.classList.add('ji-globo-ready');
    const nativeTitle = document.querySelector('#FacetDrawerSticky .drawer__title')?.textContent.trim();
    const heading = tree.querySelector('.gf-filter-heading');
    if (heading && nativeTitle && heading.textContent !== nativeTitle) heading.textContent = nativeTitle;
    tree.querySelectorAll('.gf-option-block').forEach(block => {
      if (initialized.has(block) || !block.querySelector('.gf-block-title [aria-expanded]')) return;
      initialized.add(block);
      if (!block.querySelector('[aria-checked="true"]')) {
        if (!block.classList.contains('is-collapsed')) block.classList.add('is-collapsed');
        block.querySelector('.gf-block-title [aria-expanded]')?.setAttribute('aria-expanded', 'false');
      }
    });
    if (source) {
      let wrapper = tree.querySelector('.ji-globo-sort');
      const options = Array.from(source.querySelectorAll('[data-sort]'));
      const signature = options.map(option => option.dataset.sort + option.textContent).join('|');
      if (!wrapper) {
        wrapper = document.createElement('div');
        wrapper.className = 'ji-globo-sort';
        const label = document.createElement('label');
        label.htmlFor = 'ji-globo-sort-select';
        label.textContent = document.querySelector('#FacetDrawerSticky .select-sort-by label')?.textContent.trim() || source.querySelector('[role="listbox"]')?.getAttribute('aria-label') || heading?.textContent;
        const select = document.createElement('select');
        select.id = label.htmlFor;
        select.addEventListener('change', () => {
          const option = Array.from(document.querySelectorAll('#gf-controls-container [data-sort]')).find(item => item.dataset.sort === select.value);
          option?.click();
        });
        wrapper.append(label, select);
        tree.querySelector('.gf-filter-header')?.after(wrapper);
      }
      const select = wrapper.querySelector('select');
      if (wrapper.dataset.options !== signature) {
        select.replaceChildren(...options.map(option => new Option(option.textContent.trim(), option.dataset.sort)));
        wrapper.dataset.options = signature;
      }
      const selected = options.find(option => option.textContent.trim() === source.querySelector('.sort-by-toggle')?.textContent.trim());
      if (selected && select.value !== selected.dataset.sort) select.value = selected.dataset.sort;
    }
    const opened = document.documentElement.classList.contains('offcanvas-open');
    document.querySelectorAll('button[aria-controls="FacetDrawerSticky"]').forEach(button => {
      if (button.closest('#FacetDrawerSticky')) return;
      const state = String(opened);
      if (button.getAttribute('aria-expanded') !== state) button.setAttribute('aria-expanded', state);
    });
  };
  const schedule = () => {
    if (!pending) { pending = true; requestAnimationFrame(prepare); }
  };
  document.addEventListener('click', event => {
    const button = event.target.closest?.('button[aria-controls="FacetDrawerSticky"]');
    if (!button || button.closest('#FacetDrawerSticky') || !document.querySelector('#gf-tree') || typeof window.globofilter?.toggleCanvas !== 'function') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    window.globofilter.toggleCanvas();
    schedule();
  }, true);
  const region = document.querySelector('.collection-section') || document.querySelector('#MainContent');
  if (region) new MutationObserver(records => {
    if (records.some(record => record.type === 'childList' || record.target.closest?.('#gf-tree, #gf-controls-container'))) schedule();
  }).observe(region, {childList:true, subtree:true, attributes:true, attributeFilter:['class','aria-checked']});
  new MutationObserver(schedule).observe(document.documentElement, {attributes:true, attributeFilter:['class']});
  window.addEventListener('load', schedule);
  schedule();
})();
